export enum DiffNodeRenderType {
  default = 0,
  boolean,
  referenceText,
  trainingPhrase,
  parameterCompanion,
  dataQueryName,
  dataQueryType,
  valueSuggestType,
  variable,
  connectionType,
  triggerCondition,
  responseActionType,
  paramAction,
  frame,
  prompt,
  source,
  library,
  pageOrder,
  valueRecHard,
  messageTemplate
}

export interface DiffNodeConfig {
  name?: string;
  localeNameKey?: string;
  fields: DiffFieldConfig[];
  idKey?: string;
  nameKey?: string;
  funcToServer?: (data: any) => any;
  page?: string;
}


export interface DiffFieldConfig {
  key: string;
  name?: string;
  localeNameKey?: string;
  isArray?: boolean;
  node?: DiffNodeConfig;
  renderType?: DiffNodeRenderType;
  isLeaf?: boolean;
  hasMasterSelf?: boolean;
}
